import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AmountStatus, Competitor, ConfirmPayment} from "@model";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AbstractComponent} from "@components";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
  selector: 'app-accept-competitor-registration',
  templateUrl: './accept-competitor-registration.component.html',
  styleUrl: './accept-competitor-registration.component.scss'
})
export class AcceptCompetitorRegistrationComponent extends AbstractComponent implements OnInit {
    @Input() competitor: Competitor | undefined;
    @Output() onSave = new EventEmitter<ConfirmPayment | undefined>();
    displayAmountStatus: boolean = false;
    items = [AmountStatus.EXACT, AmountStatus.OVERPAID, AmountStatus.UNDERPAID];
    itemLabels = ['account.statements.amountStatus.0', 'account.statements.amountStatus.1', 'account.statements.amountStatus.2']
    inputForm = new FormGroup({
    amountStatus: new FormControl(),
    note: new FormControl(),

    });

    constructor(public activeModal: NgbActiveModal) {
      super();
    }

    ngOnInit(): void {
      this.displayAmountStatus = !!this.competitor?.registration?.order?.id
      if (this.displayAmountStatus) {
        this.inputForm.controls.amountStatus.setValue(AmountStatus.EXACT);
      }
      this.inputForm.controls.note.setValue(this.competitor?.fee);
    }

    onConfirmClick(): void {
      const confirmPayment = new ConfirmPayment(this.competitor?.registrationId, this.competitor?.id, this.displayAmountStatus ? this.inputForm.controls.amountStatus.value : undefined, this.inputForm.controls.note.value)
      this.onSave.emit(confirmPayment);
      this.activeModal?.dismiss();
    }

    onDismissClick(): void {
      this.activeModal.dismiss();
    }

}
